var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 0H13.5C6.04416 0 0 6.04416 0 13.5V40.5C0 47.9558 6.04416 54 13.5 54H40.5C47.9558 54 54 47.9558 54 40.5V13.5C54 6.04416 47.9558 0 40.5 0Z",
    fill: "#14144A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5635 23.9941V20.7949C32.5635 18.1446 30.2615 15.9961 27.4219 15.9961C24.5822 15.9961 22.2803 18.1446 22.2803 20.7949V23.9941",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4219 21.709C23.0047 21.709 19.4238 25.2898 19.4238 29.707C19.4238 34.1242 23.0047 37.7051 27.4219 37.7051C31.8391 37.7051 35.4199 34.1242 35.4199 29.707C35.4199 25.2898 31.8391 21.709 27.4219 21.709ZM27.4219 28.707C26.8696 28.707 26.4219 29.1547 26.4219 29.707C26.4219 30.2593 26.8696 30.707 27.4219 30.707H27.4322C27.9844 30.707 28.4322 30.2593 28.4322 29.707C28.4322 29.1547 27.9844 28.707 27.4322 28.707H27.4219Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4871d5e3ffaa1ce28450a8061dd8ee55.svg";
export { ForwardRef as ReactComponent };